import el from "@cypherpotato/el";
import { joinObjects } from "../util";

export function DestructiveButton(...args) {
    const { onDestruct, delayAmount = 2 } = joinObjects(...args);
    const parsedDelayAmount = Number.parseFloat(delayAmount);
    const delayMilliseconds = Math.max(0, Number.isFinite(parsedDelayAmount) ? parsedDelayAmount : 4.5) * 1000;
    const buttonArgs = args
        .filter(arg => arg && typeof arg === "object" && !arg.nodeType && typeof arg[Symbol.iterator] !== "function")
        .map(({ onDestruct, delayAmount, ...arg }) => arg);
    const buttonChildren = args.filter(arg => !arg || typeof arg !== "object" || arg.nodeType || typeof arg[Symbol.iterator] === "function");
    var destructTimer = null;
    var destructTarget = null;
    var destructEvent = null;

    function cancelDestructing() {
        if (destructTimer != null) {
            clearTimeout(destructTimer);
            destructTimer = null;
        }

        destructTarget?.classList.remove("destructing");
        destructTarget = null;
        destructEvent = null;

        document.removeEventListener("pointerup", cancelDestructing);
        document.removeEventListener("pointercancel", cancelDestructing);
    }

    function startDestructing(event) {
        if (destructTimer != null || event.currentTarget.disabled || event.button > 0 || event.repeat) {
            return;
        }

        event.preventDefault();
        destructTarget = event.currentTarget;
        destructEvent = event;
        destructTarget.style.setProperty("--destructive-delay", `${delayMilliseconds}ms`);
        destructTarget.classList.add("destructing");

        if (event.type === "pointerdown") {
            document.addEventListener("pointerup", cancelDestructing);
            document.addEventListener("pointercancel", cancelDestructing);
        }

        destructTimer = setTimeout(() => {
            const target = destructTarget;
            const originalEvent = destructEvent;

            cancelDestructing();
            onDestruct?.call(target, originalEvent);
        }, delayMilliseconds);
    }

    return el("button.app-button.danger.destructive",
        {
            onClick(event) {
                event.preventDefault();
                event.stopImmediatePropagation();
            },
            onPointerDown: startDestructing,
            onPointerLeave: cancelDestructing,
            onPointerCancel: cancelDestructing,
            onKeyDown(event) {
                if (event.key === " " || event.key === "Enter") {
                    startDestructing(event);
                }
            },
            onKeyUp: cancelDestructing,
            onBlur: cancelDestructing
        },
        ...buttonArgs,
        el("span.destructive-button-content", ...buttonChildren));
}
